module.exports = {
	"ha": "nha",
	"id": 5.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "62%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "62%",
				"height": "38%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 68.18181818181817,
						"dataLabels": {
							"enabled": true,
							"format": "15",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.45454545454545,
						"dataLabels": {
							"enabled": true,
							"format": "10",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 40.909090909090914,
						"dataLabels": {
							"enabled": true,
							"format": "9",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 31.818181818181817,
						"dataLabels": {
							"enabled": true,
							"format": "7",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 31.818181818181817,
						"dataLabels": {
							"enabled": true,
							"format": "7",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.42857142857143,
						"dataLabels": {
							"enabled": true,
							"format": "54",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.35714285714286,
						"dataLabels": {
							"enabled": true,
							"format": "45",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.21428571428571,
						"dataLabels": {
							"enabled": true,
							"format": "41",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 58.92857142857143,
						"dataLabels": {
							"enabled": true,
							"format": "33",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": true,
							"format": "21",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.66666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "74",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84,
						"dataLabels": {
							"enabled": true,
							"format": "63",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76,
						"dataLabels": {
							"enabled": true,
							"format": "57",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.66666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "53",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 38.666666666666664,
						"dataLabels": {
							"enabled": true,
							"format": "29",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.27027027027027,
						"dataLabels": {
							"enabled": true,
							"format": "141",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.78378378378379,
						"dataLabels": {
							"enabled": true,
							"format": "124",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.02702702702703,
						"dataLabels": {
							"enabled": true,
							"format": "114",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.62162162162163,
						"dataLabels": {
							"enabled": true,
							"format": "106",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 49.32432432432432,
						"dataLabels": {
							"enabled": true,
							"format": "73",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -31.818181818181824,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.888888888888891,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.512195121951216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -36.36363636363637,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.3333333333333308,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.864864864864868,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.017543859649122,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -45.28301886792453,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.729729729729726,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.056737588652478,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.064516129032262,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.017543859649122,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -31.132075471698116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=22"
			},
			{
				"x": 9,
				"text": "30–39<br>n=56"
			},
			{
				"x": 15,
				"text": "40–49<br>n=75"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=148"
			}
		],
		"dataTable": {
			"< 30": [
				22,
				15,
				10,
				9,
				7,
				7
			],
			"30–39": [
				56,
				54,
				45,
				41,
				33,
				21
			],
			"40–49": [
				75,
				74,
				63,
				57,
				53,
				29
			],
			"≥ 50": [
				148,
				141,
				124,
				114,
				106,
				73
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_3.json
// module id = 269
// module chunks = 0